<!-- <mat-toolbar color="primary">
  <button [fxShow.lt-md]="true" [fxShow]="false"  mat-icon-button (click)="openSidenav()">
    <mat-icon>menu</mat-icon>
  </button>
  <span>Manage External Users</span>
</mat-toolbar> -->
<mat-tab-group #tabGroup mat-stretch-tabs animationDuration="0ms">
    <mat-tab label="Pending Approval Users">
        <mat-card *ngIf="tabGroup.selectedIndex === 0" style="padding: 0%;">
            <ext-management-table-component [data]='pendingApprovalData' tableType='pending'>
            </ext-management-table-component>
        </mat-card>
    </mat-tab>
    <mat-tab label="Approved/Rejected External User">
        <mat-card *ngIf="tabGroup.selectedIndex === 1" style="padding: 0%;">
            <ext-management-table-component [data]='approvedRejectedData' tableType='approved'>
            </ext-management-table-component>
        </mat-card>
    </mat-tab>
</mat-tab-group>